<template>
    <div class="user">
        <div class="condition">
            <div class="item">
                <div class="label">手机号:</div>
                <el-input v-model="conditionData.phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">微信:</div>
                <el-input v-model="conditionData.weChat" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">昵称:</div>
                <el-input v-model="conditionData.nickName" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%"
                height="600px">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="账号"
                align="center"
                >
                </el-table-column>
<!--                 
                <el-table-column
                prop="isJUser"
                label="是否真实用户"
                align="center"
                width="110px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isJUser">真实用户</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="nickName"
                label="用户昵称"
                align="center"
                >
                </el-table-column>
                
                
                
                <!-- <el-table-column
                prop="gender"
                label="性别"
                align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender==1">男</span>
                        <span v-else>女</span>
                    </template>
                </el-table-column> -->

               
                <el-table-column
                prop="weChat"
                label="微信"
                align="center"
                >
                </el-table-column>

                <el-table-column
                prop="device"
                label="设备号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="reason"
                label="原因"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{ scope.row.reason=='太丑'||!scope.row.reason?'违规行为':scope.row.reason }}</span>
                </template>
                </el-table-column>
                
                <el-table-column
                prop="creationTime"
                label="创建时间"
                align="center"
                >
                
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="220px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="sizes,prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size"
                    :page-sizes="[10,50,100 ]"
                    @size-change="handleSizeChange">
                </el-pagination>
                
            </div>
        </div>
      

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户
                    </div>
                    <div class="value">
                        <el-input v-model="addData.nickName" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        手机号
                    </div>
                    <div class="value">
                        <el-input v-model="addData.phone" size="small" placeholder="请输入" ></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        微信号
                    </div>
                    <div class="value">
                        <el-input v-model="addData.weChat" size="small" placeholder="请输入" ></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        设备号
                    </div>
                    <div class="value">
                        <el-input v-model="addData.device" size="small" placeholder="请输入" ></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        原因
                    </div>
                    <div class="value" style="width:300px">
                        <el-input type="textarea" v-model="addData.reason" size="small" placeholder="请输入" ></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="add">确认新增</el-button>
                </div>
                
            </div>
        </el-dialog>

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS} from '../../../utils/index'
import {genderList,vipList,shenHeList,enableList} from '../../../assets/selectList/anxin'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'user',
    data () {
        return {
            userId:'',
            vipList:vipList,
            enableList:enableList,
            genderList:genderList,
            shenHeList:shenHeList,
            isShow:false,
            totalCount:0,
            isDetailDialog:false,
            detailData:{},
            piclist:[],
            conditionData:{
                weChat:'',
                nickName:'',
                IsChuli:false,
                current:1,
                size:10,
            },
            tableData:[],
           

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
            userId:'',
            // 交换次数
            isSetUnlockNumber:false,
            setUnlockNumberData:{},
            // 会员设置
            isVip:false,
            vipData:{},
            // 动态次数
            isDynamicNumberDialog:false,
            dynamicNumberData:{},

            frozenData:{
                "userId": null,
                "reason": ""
            },
            isFrozenDialog:false,
            username:'',
            thawData:{
                "userId": null,
                "reason": ""
            },
            isThawDialog:false,

            isJinBiDialog:false,
            JinBiData:{
                "userId": null,
                "jinBi": 0
            },
            isEditDialog:false,
            editData:{
                "id": 0,
                "userId": 0,
                "nickName": "",
                "age": 0,
                "gender": 1,
                "city": "",
                "birthday": "",
                "shenGao": "",
                "tiZhong": "",
                "zhiYe": "",
                "love": "",
                "header": "",
                "lng": 0,
                "lat": 0,
                "address": "",
                "weChat": "",
                "unlockNumber": 0
            },
            IsJUserList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
            addData:{},
            isAddDialog:false,
        }
    },
    components:{
        ElImageViewer
    },
    created(){

    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        addDialogShow(){
            this.isAddDialog = true;
        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showHeader(url){
            this.showBigImgList = [url];
            this.showBigImg = true;

        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.QueryBlackModel(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            for(let index in this.tableData){
                this.tableData[index].Time = parseTimeS(this.tableData[index].Time);
            }
        },
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
      
        
        
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        
        // 重置
        reset(){
            this.conditionData = {
                weChat:'',
                nickName:'',
                current: 1,
                size: 10,
            },
            this.loadingData();
        },
        
        async add(){
            let res = await api.AddBlackModel(this.addData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });
                this.isAddDialog = false;
                this.loadingData();
            }
        },
        deleteTip(item){
            this.$confirm('将删除此数据?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(row){
            let res = await api.DeleteBlackModel(row);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });
                this.isAddDialog = false;
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        
        ::v-deep .table-expand {
            font-size: 0;
        }
        .row{
            display: flex;
        }
        ::v-deep .table-expand label {
            width: 150px;
            padding-left: 50px;
            color: #99a9bf;
        }
        ::v-deep .table-expand span {
            color: #222222;
        }
        ::v-deep .table-expand .btn span{
            color: #409eff;
        }
        ::v-deep .table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 450px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .valuet{
                width: 450px;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
